import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);
  const [selectedSize, setSelectedSize] = useState(
    product?.size ? product.size[0] : ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  if (!product) {
    return <div>Product not found</div>;
  }

  const handleAddToCart = () => {
    if (product.size && product.size.length > 0 && !selectedSize) {
      alert("Please select a size.");
      return;
    }

    addToCart(product.id, quantity, selectedSize);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleQuantityChange = (type) => {
    if (type === "increase") {
      setQuantity(quantity + 1);
    } else if (type === "decrease" && quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="prestige--v4 features--heading-small features--heading-uppercase template-index">
      <div className="PageContainer">
        <Header />

        <div className="product-detail-page">
          {/* Breadcrumb Navigation */}
          <nav className="breadcrumb">
            <Link onClick={toTop} to="/">
              Home
            </Link>{" "}
            /{" "}
            <Link onClick={toTop} to="/shop">
              Shop All Jewelry
            </Link>{" "}
            / {product.category}
          </nav>

          <div className="product-container">
            {/* Left Side - Image Gallery */}
            <div className="product-gallery">
              <div className="thumbnail-list">
                {product.images.map((image, index) => (
                  <div
                    key={index}
                    className={`thumbnail ${
                      selectedImage === index ? "active" : ""
                    }`}
                    onClick={() => setSelectedImage(index)}
                  >
                    <img src={image} alt={`${product.name} ${index + 1}`} />
                  </div>
                ))}
              </div>
              <div className="main-image">
                <img src={product.images[selectedImage]} alt={product.name} />
              </div>
            </div>

            {/* Right Side - Product Info */}
            <div className="product-info">
              <h1 className="product-name">{product.name}</h1>
              <p className="product-price">${product.price}</p>

              {/* Size Selector */}
              {product.size && product.size.length > 0 && (
                <div className="size-section">
                  <div className="size-label">
                    <strong>Size:</strong>
                  </div>
                  <div className="size-options">
                    {product.size.map((size) => (
                      <button
                        key={size}
                        className={`size-btn ${selectedSize === size ? 'active' : ''}`}
                        onClick={() => setSelectedSize(size)}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Quantity Selector */}
              <div className="quantity-section">
                <div className="quantity-label">
                  <strong>Quantity:</strong>
                </div>
                <div className="quantity-controls">
                  <button
                    onClick={() => handleQuantityChange("decrease")}
                    className="quantity-btn"
                    disabled={quantity <= 1}
                  >
                    −
                  </button>
                  <span className="quantity-display">{quantity}</span>
                  <button
                    onClick={() => handleQuantityChange("increase")}
                    className="quantity-btn"
                  >
                    +
                  </button>
                </div>
              </div>

              <button className="add-to-bag-btn" onClick={handleAddToCart}>
                ADD TO BAG
              </button>

              {/* Stock Status */}
              <div className="stock-status">
                <p>
                  {product.status === "available" ? (
                    <>
                      <span style={{ color: "#4CAF50" }}>●</span> In Stock -
                      Ships within 2-3 business days
                    </>
                  ) : (
                    <>
                      <span style={{ color: "#FF5722" }}>●</span> Out of Stock
                    </>
                  )}
                </p>
              </div>

              {/* Product Features */}
              <div className="product-features">
                <ul>
                  {product.features.slice(0, 5).map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              {/* Product Description */}
              <div className="product-description">
                {product.description.map((desc, index) => (
                  <p key={index}>{desc}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ProductDetail;
